import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'; // Link
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Tab,Nav} from 'react-bootstrap'; // Col 

import ModalWindow from '../../commons/helpers/modalWindow'; 
import Toast from '../../commons/helpers/toast';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { ROUTE_REFRESH, LOGIN_AFFILIATE_GROUP, DELETE_SYMBOL } from '../../../configs/staticConfigs';
import {  MSG_MASTER_RATE_CARD_UPDATE_SUCCESS, MSG_MASTER_RATE_CARD_UPDATE_ERROR, MSG_RATE_MISMATCH, MSG_ERROR, MSG_DATA_FETCH_CHIEF_BONUS_ERROR, MSG_DATA_UPDATE_CHIEF_BONUS_SUCCESS, MSG_DATA_UPDATE_CHIEF_BONUS_ERROR, MSG_REQUIRED, MSG_CHIEF_CHARGE_RATE_ERROR } from '../../../configs/msgConfigs'; //  MSG_NOT_VALID_ERROR MSG_PAYRATE_REQUIRED MSG_CHARGERATE_REQUIRED
import { LBL_APP_NAME, LBL_SETTINGS, LBL_SKILL, LBL_MASTER_RATE_CARD, LBL_PAY_RATE, LBL_CHARGE_RATE, LBL_HOURS, LBL_CREW_CHIEF, LBL_CHIEF_PAY_RATE, LBL_CHIEF_CHARGE_RATE, LBL_SAVE, LBL_BTN_ADD_STC, LBL_FOR, LBL_HRS_ABOVE, LBL_HOUR_SHORT, LBL_HOURS_SHORT, LBL_CONFIRM_DELETE_ROW, LBL_REMOVE_ROW,LBL_CONFIRM_DELETE } from '../../../configs/labelConfigs';

import { aflt_mRateCardListAction, aflt_mRateCardUpdateAction, getAffiliateChiefBonusAction,  updateAffiliateChiefBonusAction } from '../../../actions/settings/affiliates/aflt_masterratecardActions'; 
import {clearAction} from '../../../actions/commonActions';
import { MASTER_RATE_CARD_LIST_AFFILIATE_SUCCESS, MASTER_RATE_CARD_UPDATE_AFFILIATE_SUCCESS, MASTER_RATE_CARD_UPDATE_AFFILIATE_ERROR, MASTER_RATE_CARD_LIST_AFFILIATE_ERROR, GET_AFFILIATE_CHEIF_BONUS_SUCCESS, GET_AFFILIATE_CHEIF_BONUS_ERROR, UPDATE_AFFILIATE_CHEIF_BONUS_SUCCESS, UPDATE_AFFILIATE_CHEIF_BONUS_ERROR } from '../../../actions'; 

import { decimalNumRegex, checkNumDot, checkNumDotZero} from '../../../utils/validation'; // formValid, 

import { changeColorBlue, changeColorNormal} from '../../../utils/displayFormats'; 


// import NavbarCollapse from 'react-bootstrap/NavbarCollapse';
import {decimalTwo} from '../../../utils/commonUtilities'; 
import {format as stringFormat} from 'react-string-format';

class MasterRateCardComponent extends Component {

    constructor(props){
        super(props)

        let profileId = '';

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup    = ''; 
        let grpProfileId = '';
        let profileCurrency = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            grpProfileId = userGroupData.profile_id;
            profileCurrency = userGroupData.profile_currency; 
        }

        if(userGroup===LOGIN_AFFILIATE_GROUP){
            profileId = grpProfileId;
        }else{
            profileId = this.props.match.params.id;
        }

        this.state = {    
            skillRatesAllData: [],  
            activeSkillRateData: { skill_id: 0, skill_name: '', rates_data: [] },    
            activeSkillId: 0,     
            deleteRowIndexNum: 0,                      
            formErrors:{
                fieldEmpty:'',
                crewChiefChargeRateLess: '',
                crewChiefPayRate: '',
                crewChiefChargeRate: ''               
            },          
            profileId:profileId,
            profileCurrency:profileCurrency,
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false,
            activeSkillName:'',
            crewChiefPayRate: 0,
            crewChiefChargeRate: 0,
            isCrewChiefActive: 1
        }

        this.onHandleChange = this.onHandleChange.bind(this);
        this.saveFormData   = this.saveFormData.bind(this);
        this.changeSkill = this.changeSkill.bind(this); 
        this.addNewRow = this.addNewRow.bind(this); 
        this.removeRow = this.removeRow.bind(this); 
        this.checkFormData = this.checkFormData.bind(this); 
        this.modalDelete = React.createRef();
    }

    componentDidMount() {
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_MASTER_RATE_CARD;
        document.body.classList.add('body-affiliate'); 
        this.props.getAffiliateChiefBonusAction({id:this.state.profileId}); 
        this.props.aflt_mRateCardListAction();   
    }

    changeSkill = (event, refSkillId,skillName) => {
        let allSkillRateObj = []; 
        let newActiveObj = {};
        if(skillName===LBL_CREW_CHIEF) {
            this.setState({ isCrewChiefActive:1, activeSkillId:0, activeSkillRateData: newActiveObj,toastFlag:false,toastMessage:'',toastSuccess:true,activeSkillName:''}); 
        }
        else if(this.state.activeSkillId!==refSkillId) {
            this.state.skillRatesAllData.forEach((item,index) => {
                if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(this.state.activeSkillRateData); 
                else allSkillRateObj.push(item); 
                if(item.skill_id===refSkillId)  {
                    newActiveObj = item;
                }
            }); 
            this.setState({isCrewChiefActive:0,activeSkillId:refSkillId, activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj,toastFlag:false,toastMessage:'',toastSuccess:true,activeSkillName:skillName});  
        }   
    }

    onHandleChange = (e, rateIndex,fieldName) =>{
        e.preventDefault();
        // this.setState({formClick:true}); // to track form update without any value change in component did update 
        const {value}  = e.target;
        let formErrors      = this.state.formErrors;
        let activeData      = this.state.activeSkillRateData; 
        let valStr = value.trim(); 
        let finalIndex = 0;
        if(fieldName==='crewChiefPayRate') {  
            formErrors.crewChiefChargeRateLess = ''; 
            formErrors.crewChiefPayRate = valStr.length <=0 || decimalNumRegex.test(valStr) === false
            ? MSG_REQUIRED : ""; 
            if(valStr && valStr !== '' && !checkNumDotZero(valStr)) { valStr = ''; }
            else if(valStr && valStr !== '') {
                let t = valStr; 
                valStr = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
            }
            this.setState({formClick:true, crewChiefPayRate:valStr, formErrors});  
        }     

        if(fieldName==='crewChiefChargeRate') { 
            formErrors.crewChiefChargeRateLess = ''; 
            formErrors.crewChiefChargeRate = valStr.length <=0 || decimalNumRegex.test(valStr) === false
            ? MSG_REQUIRED : "";
            if(valStr && valStr !== '' && !checkNumDotZero(valStr)) { valStr = ''; }
            else if(valStr && valStr !== '') {
                let t = valStr; 
                valStr = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
            }
            this.setState({formClick:true, crewChiefChargeRate:valStr, formErrors});  
        }


        // activeSkillRateData rates_data  hours pay_rate charge_rate is_final 
        if(fieldName==='pay_rate') {
            formErrors.fieldEmpty = ''; 
            if(!checkNumDotZero(valStr))  {
                //formErrors.fieldEmpty = MSG_NOT_VALID_ERROR; 
                valStr = ''; 
            }
            valStr = decimalTwo(valStr); 
            activeData.rates_data[rateIndex].pay_rate = valStr; 
            if(Number(rateIndex)===0) {
                finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
                activeData.rates_data[finalIndex].pay_rate = valStr; 
            }
            this.setState({formClick:true,activeSkillRateData:activeData, formErrors:formErrors});  
        } 
        else if(fieldName==='charge_rate') { 
            formErrors.fieldEmpty = ''; 
            if(!checkNumDotZero(valStr))  {
                //formErrors.fieldEmpty = MSG_NOT_VALID_ERROR; 
                valStr = ''; 
            }
            valStr = decimalTwo(valStr); 
            activeData.rates_data[rateIndex].charge_rate = valStr; 
            if(Number(rateIndex)===0) {
                finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
                activeData.rates_data[finalIndex].charge_rate = valStr; 
            }
            this.setState({formClick:true,activeSkillRateData:activeData, formErrors:formErrors});  
        }
    } 

    addNewRow = () => {
        let newRateObj = [];
        let newItem = {};
        this.state.activeSkillRateData.rates_data.forEach((item,index) => {
            if(item.is_final) {
                newItem = { hours: item.hours, pay_rate: parseFloat(0.00).toFixed(2), charge_rate: parseFloat(0.00).toFixed(2), is_final: false};
                newRateObj.push(newItem); 
                newItem = { hours: (item.hours+1), pay_rate: parseFloat(item.pay_rate).toFixed(2), charge_rate: parseFloat(item.charge_rate).toFixed(2), is_final: item.is_final};
                newRateObj.push(newItem); 
            }
            else {
                newRateObj.push(item); 
            }
        }); 
        // { skill_id: 0, skill_name: '', rates_data: [], is_final: false }
        let newActiveObj = this.state.activeSkillRateData; 
        newActiveObj.rates_data = newRateObj; 
        
        let allSkillRateObj = []; 
        this.state.skillRatesAllData.forEach((item,index) => {
            if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(newActiveObj); 
            else allSkillRateObj.push(item); 
        }); 

        this.setState({formClick:true,activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj}); 
    }

    removeRow = (rateIndex) => {
        let newRateObj = [];
        let newItem = {};
        let rowRemoved = 0; 
        this.state.activeSkillRateData.rates_data.forEach((item,index) => {
            if(index<rateIndex) newRateObj.push(item); 
            else {
                if(rowRemoved===0) {
                    rowRemoved++; 
                }
                else {
                    newItem = { hours: (item.hours-1), pay_rate: item.pay_rate, charge_rate: item.charge_rate, is_final: item.is_final};
                    newRateObj.push(newItem); 
                }
            }
        }); 
        // { skill_id: 0, skill_name: '', rates_data: [], is_final: false}
        let newActiveObj = this.state.activeSkillRateData; 
        newActiveObj.rates_data = newRateObj; 
        
        let allSkillRateObj = []; 
        this.state.skillRatesAllData.forEach((item,index) => {
            if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(newActiveObj); 
            else allSkillRateObj.push(item); 
        }); 

        let frmErr = this.state.formErrors; 
        frmErr.fieldEmpty = ''; 
        this.setState({formErrors: frmErr, formClick:true, activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj}); 
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:true});
    } 

    onModalFormReset = () =>{ 
        this.setState({deleteRowIndexNum:0}); 
    }
    
    deleteBtnClick = (indexNum) =>{
        let pRate = this.state.activeSkillRateData.rates_data[indexNum].pay_rate; 
        let cRate = this.state.activeSkillRateData.rates_data[indexNum].charge_rate; 
        if( ((parseFloat(pRate) <= 0) || (pRate==='')) && (parseFloat(cRate) <= 0 || (cRate===''))) {
            this.setState({deleteRowIndexNum: indexNum}, () => this.removeRow(this.state.deleteRowIndexNum)); 
        }
        else {
            this.setState({deleteRowIndexNum: indexNum}, () => this.modalDelete.current.handleOpenModal()); 
        }
    }

    onDeleteAction = () =>{
        if(this.state.deleteRowIndexNum > 0) this.removeRow(this.state.deleteRowIndexNum);
        this.modalDelete.current.handleModelClose();              
    }

    checkFormData() {
        let foundError = 0; 
        let errMsg = this.state.formErrors; 
        this.state.activeSkillRateData.rates_data.map((item,index) => {
            if(parseFloat(item.pay_rate)===0 || parseFloat(item.charge_rate)===0) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(item.pay_rate==='' || item.charge_rate==='' || item.pay_rate===0 || item.charge_rate===0) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(!checkNumDot(item.pay_rate) || item.pay_rate===0) {  // checkNumDot,
                foundError = 1; 
                // errMsg.fieldEmpty = MSG_PAYRATE_REQUIRED;
                // this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(!checkNumDot(item.charge_rate) || item.charge_rate===0) {  
                foundError = 1; 
                //errMsg.fieldEmpty = MSG_CHARGERATE_REQUIRED;
                //this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(parseFloat(item.pay_rate) > parseFloat(item.charge_rate)) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
            return(console.log('.')); 
        }); 
        if(foundError===0) {
            return true; 
        }
     }
  
    saveFormData = (e)=>{
        e.preventDefault(); 
        this.setState({formClick:true});
        if(this.checkFormData()) {
            let saveDataObj = {
                skill_id : this.state.activeSkillRateData.skill_id,
                skill_name : this.state.activeSkillRateData.skill_name,
                rates_data : this.state.activeSkillRateData.rates_data
            };
            this.props.aflt_mRateCardUpdateAction(saveDataObj);  
        }
    }

    saveChiefBonusData = (e)=>{ 
        e.preventDefault(); 
        this.setState({formClick:true});
        if(parseFloat(this.state.crewChiefPayRate) > parseFloat(this.state.crewChiefChargeRate)) {
            let formErrors = this.state.formErrors;
            let userGroupData = userGroupUrlCheck(window.location);
            let msg_toast = ''; 
            if(userGroupData!==undefined){
                msg_toast = stringFormat(MSG_CHIEF_CHARGE_RATE_ERROR,userGroupData.supervisor_name,userGroupData.supervisor_name);
            }   
            formErrors.crewChiefChargeRateLess  = msg_toast;   
            this.setState({formErrors}); 
        }
        else {
            let saveDataObj = {
                id:this.state.profileId,
                crew_chief_bonus : this.state.crewChiefChargeRate,
                crew_chief_pay_bonus : this.state.crewChiefPayRate
            }; 
            this.props.updateAffiliateChiefBonusAction(saveDataObj);  
        }
    }

    componentDidUpdate(prevProps) {       
        const { status, activity, chiefRateBonus, errorData } = this.props;

        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            if(status!==401) {   
                var arrResp = activity.split('~~'); 
                var actString = arrResp[0]; 
                if(actString===GET_AFFILIATE_CHEIF_BONUS_SUCCESS){  
                    if(status===200) {
                        // {id: 158, crew_chief_bonus: "12.00", crew_chief_pay_bonus: "8.00"}
                        let crewChiefPayRate = 0; 
                        let crewChiefChargeRate = 0; 
                        if(chiefRateBonus) {
                            if(chiefRateBonus.hasOwnProperty('crew_chief_bonus')) crewChiefChargeRate = chiefRateBonus.crew_chief_bonus; 
                            if(chiefRateBonus.hasOwnProperty('crew_chief_pay_bonus')) crewChiefPayRate = chiefRateBonus.crew_chief_pay_bonus; 
                            this.setState({isCrewChiefActive:1,crewChiefPayRate,crewChiefChargeRate}); 
                        }
                    }
                    else {
                        console.log(errorData);
                        let userGroupData = userGroupUrlCheck(this.props.location);
                        let msg_toast = '';  
                        if(userGroupData!==undefined){
                            msg_toast = stringFormat(MSG_DATA_FETCH_CHIEF_BONUS_ERROR,userGroupData.supervisor_name); 
                        } 
                        this.setState({toastFlag:true, toastSuccess:false, toastMessage:msg_toast});
                        setTimeout(()=> { this.onCloseToast(); }, 5000);
                    }
                } 
                else if(actString===GET_AFFILIATE_CHEIF_BONUS_ERROR) {
                    console.log(errorData);
                    let userGroupData = userGroupUrlCheck(this.props.location);
                    let msg_toast = '';  
                    if(userGroupData!==undefined){
                        msg_toast = stringFormat(MSG_DATA_FETCH_CHIEF_BONUS_ERROR,userGroupData.supervisor_name); 
                    } 
                    this.setState({toastFlag:true, toastSuccess:false, toastMessage:msg_toast});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }

                if(actString===UPDATE_AFFILIATE_CHEIF_BONUS_SUCCESS){ 
                    if(status===200) {
                        let userGroupData = userGroupUrlCheck(this.props.location);
                        let msg_toast = '';  
                        if(userGroupData!==undefined){
                            msg_toast = stringFormat(MSG_DATA_UPDATE_CHIEF_BONUS_SUCCESS,userGroupData.supervisor_name); 
                        }
                        this.setState({toastFlag:true, toastSuccess:true, toastMessage:msg_toast});
                        setTimeout(()=> { this.onCloseToast(); }, 4000);
                    }
                    else {
                        let userGroupData = userGroupUrlCheck(this.props.location);
                        let msg_toast = '';  
                        if(userGroupData!==undefined){
                            msg_toast = stringFormat(MSG_DATA_UPDATE_CHIEF_BONUS_ERROR,userGroupData.supervisor_name); 
                        }
                        this.setState({toastFlag:true, toastSuccess:false, toastMessage:msg_toast});
                        setTimeout(()=> { this.onCloseToast(); }, 5000);
                    }
                }
                else if(actString===UPDATE_AFFILIATE_CHEIF_BONUS_ERROR) {
                    let userGroupData = userGroupUrlCheck(this.props.location);
                    let msg_toast = '';  
                    if(userGroupData!==undefined){
                        msg_toast = stringFormat(MSG_DATA_UPDATE_CHIEF_BONUS_ERROR,userGroupData.supervisor_name); 
                    }
                    this.setState({toastFlag:true, toastSuccess:false, toastMessage:msg_toast});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
                

                if(actString===MASTER_RATE_CARD_LIST_AFFILIATE_SUCCESS){ 
                    if(this.props.hasOwnProperty('skillRatesAllData')) {
                        if(this.props.skillRatesAllData.length===0) {
                            this.setState({skillRatesAllData: []}); 
                        }
                        else {
                            //let activeSkillName = this.props.skillRatesAllData[0].skill_name;
                            let tmpObj = {};
                            let rateObj = {};
                            //let firstObj ={}; 
                            //let firstSkillId = 0; 
                            let maxHour = 1; 
                            let cnt = 0;
                            let allSkillsObj = []; 
                            let newRateObj = [];
                            this.props.skillRatesAllData.forEach((rObj) => { 
                                cnt++; 
                                if(!Array.isArray(rObj.rates_data)) rObj.rates_data = []; 
                                if(rObj.rates_data && rObj.rates_data.length===0) {
                                    maxHour = 2; 
                                    newRateObj = [
                                        { hours: 1, pay_rate: 0.00, charge_rate: 0.00, is_final: false},
                                        { hours: 2, pay_rate: 0.00, charge_rate: 0.00, is_final: true},
                                    ]; 
                                }
                                else if(rObj.rates_data) { 
                                    rateObj =  rObj.rates_data; 
                                    newRateObj = [];
                                    rObj.rates_data.forEach(tmpItem => {
                                        maxHour = tmpItem.hours > maxHour ? tmpItem.hours : maxHour;
                                        tmpItem.pay_rate = parseFloat(tmpItem.pay_rate).toFixed(2); 
                                        tmpItem.charge_rate = parseFloat(tmpItem.charge_rate).toFixed(2); 
                                        newRateObj.push(tmpItem); 
                                    });
                                }                         

                                tmpObj = {
                                    skill_id: rObj.skill_id,
                                    skill_name: rObj.skill_name, 
                                    rates_data: newRateObj,
                                    is_final: rObj.is_final
                                };
                                if(cnt===1) { 
                                    //firstObj = tmpObj; 
                                    //firstSkillId = rObj.skill_id;
                                }
                                allSkillsObj.push(tmpObj);
                                //return(console.log('.')); 
                            });
                            this.setState({activeSkillId:0, activeSkillRateData: {}, skillRatesAllData: allSkillsObj,activeSkillName:''}); // firstSkillId
                        }
                    } 
                    else { 
                        this.setState({skillRatesAllData: []}); 
                    }
                } 
                else if(actString===MASTER_RATE_CARD_LIST_AFFILIATE_ERROR) { 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ERROR});
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }
                else if(actString===MASTER_RATE_CARD_UPDATE_AFFILIATE_SUCCESS){
                    this.setState({toastSuccess:true, toastFlag:true,toastMessage:MSG_MASTER_RATE_CARD_UPDATE_SUCCESS});
                    // this.setToasterState(true,MSG_APPAYRATE_ADD_SUCCESS,true);
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }
                else if(actString===MASTER_RATE_CARD_UPDATE_AFFILIATE_ERROR) {
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_MASTER_RATE_CARD_UPDATE_ERROR}); 
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }  

            }
        }else if (activity !== prevProps.activity) {
            
        }
    }
    

    render(){
      
        const { status } = this.props;
        let { profileCurrency,toastMessage, toastFlag, toastSuccess, activeSkillRateData,activeSkillName } = this.state;        


        if(!Array.isArray(activeSkillRateData.rates_data)) activeSkillRateData.rates_data = [];      

        if(status===401 || status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        let userGroupData = userGroupUrlCheck(window.location);
        let lblCrewChief = '';
        let lblChiefPayRate = ''; 
        let lblChiefChargeRate = '';  
        if(userGroupData!==undefined){
            lblCrewChief = userGroupData.supervisor_name;
            lblChiefPayRate = stringFormat(LBL_CHIEF_PAY_RATE,userGroupData.supervisor_name); 
            lblChiefChargeRate = stringFormat(LBL_CHIEF_CHARGE_RATE,userGroupData.supervisor_name); 
        }

        return(
            <React.Fragment>

                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <Tab.Container id="rateCard-tab" defaultActiveKey="rateCard-chief-rate-tab">
                    <div className="col-md-5 col-lg-4 col-xl-3 col-12">
                        <div className="box">
                            <div className="tab-head">
                            <div className="text-bold normalText leftPanelHeading ">{LBL_SKILL}</div>
                            </div>
                        </div>
                        <Nav variant="pills" className="rate-card nav flex-column nav-pills box">

                            <Nav.Link eventKey="rateCard-chief-rate-tab" onClick={(e) => this.changeSkill(e, 0, LBL_CREW_CHIEF)} >
                                { (this.state.isCrewChiefActive > 0) && 
                                <span className='spanPointer blueText text-bold ' > {lblCrewChief} </span> }
                                { (this.state.isCrewChiefActive===0) && 
                                <span className='spanPointer text-bold normalText' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal}  onClick={(e) => this.changeSkill(e, 0, LBL_CREW_CHIEF)}> {lblCrewChief} </span> }
                            </Nav.Link>  

                            {this.state.hasOwnProperty('skillRatesAllData') && this.state.skillRatesAllData.map((item,index) => { 
                            return(
                                <Nav.Link eventKey="rateCard-details-tab" onClick={(e) => this.changeSkill(e, item.skill_id,item.skill_name)} key={item.skill_id}>
                                    { (this.state.activeSkillId===item.skill_id) && 
                                    <span className='spanPointer blueText ' > {item.skill_name} </span> 
                                    }
                                    { (this.state.activeSkillId!==item.skill_id) && 
                                    <span className='spanPointer normalText' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal}  onClick={(e) => this.changeSkill(e, item.skill_id)} >  {item.skill_name} </span>
                                    }
                                </Nav.Link>
                            ) } ) }
                        </Nav>
                    </div>
                    <div className="col-md-4 col-lg-7 col-xl-8 col-10 pl-0">
                        <Tab.Content>
                            <Tab.Pane eventKey="rateCard-chief-rate-tab">
                                <div className="box">
                                    <div className="tab-head">
                                        <div className="float-left"><h6>{lblCrewChief}</h6></div>
                                        <div className="float-right paddingRight23">&nbsp;</div>
                                    </div>
                                    <div className="box-content">
                                        <div className="table-responsive">
                                            <table id="data-table" className='table col-12'  >
                                                <thead>
                                                    <tr className="text-bold">
                                                        <th className="text-left">{lblChiefPayRate+' ('+profileCurrency+')'}</th>
                                                        <th className="text-left">{lblChiefChargeRate+' ('+profileCurrency+')'}</th>
                                                        <th className="text-left">&nbsp;</th>
                                                        <th className="text-left">&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>    
                                                        <td className="text-left">
                                                            <div className="form-group text-input"><input type="text" name="crewChiefPayRate" className={this.state.formErrors.crewChiefPayRate.length >0 ? "input-num-80 input-error" : 'input-num-80'} onChange={(e) => this.onHandleChange(e,0,'crewChiefPayRate')} value={this.state.crewChiefPayRate} maxLength={8}/></div>
                                                        </td>
                                                        <td className="text-left">
                                                            <div className="form-group text-input"><input type="text" name="crewChiefChargeRate" className={this.state.formErrors.crewChiefChargeRate.length >0 ? "input-num-80 input-error" : 'input-num-80'} onChange={(e) => this.onHandleChange(e,0,'crewChiefChargeRate')} value={this.state.crewChiefChargeRate} maxLength={8}/></div>
                                                        </td>
                                                        <th className="text-left">&nbsp;</th>
                                                        <th className="text-left">&nbsp;</th>
                                                    </tr>   
                                                    <tr> 
                                                        <td colSpan="4"> 
                                                            <div className="divFloatRight">
                                                                {this.state.formErrors.crewChiefChargeRateLess.length >=0 && <div className="text-red"><small>{this.state.formErrors.crewChiefChargeRateLess}</small></div>}
                                                                <div className="divFloatRight"><button className="btn btn-primary launch-modal saveBtnMinWidth" onClick={this.saveChiefBonusData} > {LBL_SAVE} </button></div> 
                                                            </div>   
                                                        </td>
                                                    </tr> 
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>              
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="rateCard-details-tab">
                                <div className="box">
                                    <div className="tab-head">
                                        <div className="float-left"><h6>{activeSkillName}</h6></div>
                                        <div className="float-right paddingRight23"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addNewRow()} >{LBL_BTN_ADD_STC}</button></div>
                                    </div>
                                    <div className="box-content">
                                    <div className="table-responsive">
                                        {this.state.hasOwnProperty('activeSkillRateData') && 
                                        <table id="data-table" className='table'>
                                            <thead>
                                            <tr className="text-bold">
                                                <th className="text-center">{LBL_HOURS}</th>
                                                <th className="text-left">&nbsp;</th>

                                                <th className="text-left width-20-percent">{LBL_PAY_RATE+' ('+profileCurrency+')'}</th>
                                                <th className="text-left">&nbsp;</th>

                                                <th className="text-left width-20-percent">{LBL_CHARGE_RATE+' ('+profileCurrency+')'}</th>
                                                <td className="text-left">&nbsp;</td>
                                                <td className="text-left">&nbsp;</td>
                                            </tr>
                                            </thead> 
                                            <tbody>
                                            
                                            {activeSkillRateData.rates_data && activeSkillRateData.rates_data.map( (rateObj,rateIndex) => {  
                                            if(!rateObj.is_final) return( 
                                                <tr key={activeSkillRateData.skill_id+'_'+rateObj.hours}> 
                                                    <td className="text-center">{rateObj.hours} </td>
                                                     <td className="text-left">&nbsp;</td>
                                                    {/*<td className="text-left">&nbsp;</td> */}
                                                   

                                                    <td className="text-left"> 
                                                        <div className="form-group text-input">
                                                            <input className={(parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate) <= 0 || this.state.activeSkillRateData.rates_data[rateIndex].pay_rate.trim()==='') ? "input-error input-num-65" : 'input-num-65'} name={"txt_payRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].pay_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'pay_rate')} maxLength = {10} /> {LBL_FOR.toLowerCase()+' '+rateObj.hours} {Number(rateObj.hours)===1 ? ' '+LBL_HOUR_SHORT.toLowerCase() : ' '+LBL_HOURS_SHORT.toLowerCase()}
                                                        </div> 
                                                    </td>
                                                     <td className="text-left">&nbsp;</td>
                                                   {/* <td className="text-left">&nbsp;</td> */}

                                                    <td className="text-left"> <div className="form-group text-input"><input className={(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate <= 0  || this.state.activeSkillRateData.rates_data[rateIndex].charge_rate.trim()==='' || (parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate) < parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate))) ? "input-error input-num-65" : 'input-num-65'} name={"txt_chargeRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].charge_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'charge_rate')} maxLength = {10} /> {LBL_FOR.toLowerCase()+' '+rateObj.hours} {Number(rateObj.hours)===1 ? ' '+LBL_HOUR_SHORT.toLowerCase() : ' '+LBL_HOURS_SHORT.toLowerCase()}</div>
                                                    </td>
                                                    {/*<td className="text-left">&nbsp;</td> */}
                                                    <td className="text-left">{rateObj.hours > 1 && (activeSkillRateData.rates_data.length-1)===rateObj.hours && <i className={DELETE_SYMBOL} title={LBL_REMOVE_ROW} onClick={(e) => this.deleteBtnClick(rateIndex)} ></i>}</td>    
                                                    <td className="text-left">&nbsp;</td>                
                                                </tr>
                                            ) 
                                            if(rateObj.is_final) return(
                                            //     <tr key={activeSkillRateData.skill_id+'_'+rateObj.hours}> 
                                            //     <td colSpan="12"> 
                                            //         {this.state.formErrors.fieldEmpty.length >0 && (
                                            //             <div className="text-red to-right text-12 text-right">{this.state.formErrors.fieldEmpty}</div>
                                            //         )} 
                                            // </td>
                                            // </tr> 
                                            <tr key={activeSkillRateData.skill_id+'_'+rateObj.hours}> 
                                                <td className="text-center verticalTop" >{LBL_FOR} <span className="text-bold text-15">{this.state.activeSkillRateData.rates_data.length}</span> {LBL_HRS_ABOVE}</td> 
                                                 <td className="text-left">&nbsp;</td>
                                                {/*<td className="text-left">&nbsp;</td> */}

                                                <td className="text-left verticalTop"><div className="form-group text-input"><input className={parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate) <= 0 ? "input-error input-num-65" : 'input-num-65'} name={"txt_payRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].pay_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'pay_rate')} maxLength = {10}/> /{LBL_HOUR_SHORT.toLowerCase()} </div></td> 
                                                <td className="text-left">&nbsp;</td>

                                                <td className="text-left verticalTop"><div className="form-group text-input"><input className={(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate <= 0 || (parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate) < parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate))) ? "input-error input-num-65" : 'input-num-65'}  name={"txt_chargeRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].charge_rate} onChange={(e) => this.onHandleChange(e, rateIndex,'charge_rate')} maxLength = {10}/> /{LBL_HOUR_SHORT.toLowerCase()}</div> </td> 
                                                <td className="text-left verticalTop">&nbsp;</td>

                                                <td className="text-right verticalTop">
                                                    {this.state.formErrors.fieldEmpty.length >0 && (
                                                         <div className="text-red to-right text-right"><small>{this.state.formErrors.fieldEmpty}</small></div>
                                                     )} 
                                                    <div className="divFloatRight paddingRight3"><button className="btn btn-primary launch-modal saveBtnMinWidth" onClick={this.saveFormData} > {LBL_SAVE} </button></div> </td>
                                            </tr>
                                            ) 
                                            }
                                        
                                            )}
                                            
                                            </tbody>
                                        </table>
                                        }    
                                        </div>
                                    </div>    
                                </div>       
                            </Tab.Pane>
                        </Tab.Content>
                    </div>

                </Tab.Container>

                {/* <Tab.Container id="profile-tab" defaultActiveKey="company-info-tab"> */}
                    {/* <Col md={4} lg={2}>
                        <div className="box">
                            <div className="table-responsive">
                                <table id="data-table" className="table" >
                                    <thead className="text-bold">
                                        <tr className="text-bold">
                                            <th><div className="text-bold headerRowHeight ">{LBL_SKILL}</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    
                                    {this.state.hasOwnProperty('skillRatesAllData') && this.state.skillRatesAllData.map((item,index) => { 
                                        return(
                                        <tr key={item.skill_id}> 
                                            { (this.state.activeSkillId===item.skill_id) && 
                                            <td><span className='spanPointer blueText' > {item.skill_name} </span></td>
                                            }
                                            { (this.state.activeSkillId!==item.skill_id) && 
                                            <td><span className='spanPointer' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal}  onClick={(e) => this.changeSkill(e, item.skill_id)} > {item.skill_name} </span></td>
                                            }
                                        </tr>
                                    ) } ) }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Col> */}

                    
                    <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}> {LBL_CONFIRM_DELETE_ROW} </ModalWindow>  
                {/* </Tab.Container>                */}
            </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
    return {
        skillRatesAllData:state.masterRateCard.skillRateAllItems.data,
        status:state.masterRateCard.status,
        activity:state.masterRateCard.activity,
        chiefRateBonus:state.masterRateCard.chiefRateBonus, 
        errorData:state.masterRateCard.errorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_mRateCardListAction:aflt_mRateCardListAction,
        aflt_mRateCardUpdateAction:data=>aflt_mRateCardUpdateAction(data), 
        getAffiliateChiefBonusAction:getAffiliateChiefBonusAction,
        updateAffiliateChiefBonusAction:updateAffiliateChiefBonusAction,
        clearAction:clearAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(MasterRateCardComponent);
